// extracted by mini-css-extract-plugin
export default {"container":"cart_container__SXkr0","sideMenu":"cart_sideMenu__aVsyH","content":"cart_content__H2FM5"};